import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://aifvpxufenyorlrwvqgf.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFpZnZweHVmZW55b3Jscnd2cWdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE0NzIxODUsImV4cCI6MjA1NzA0ODE4NX0.nf90oO6AuadsSV0QCumE6gHVOyp5NylqoExANN9D4Mw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);